const $ = require('jquery');
const aos = require('aos');
const ww = require('./../../../../weirdwolfpack/assets/js/_main.js');
require("bootstrap");
require("slick-carousel");
require('hamburgers');

const header_scroll = ($) => {

  let header = $('#main-header');

  if ($(window).scrollTop() >= $(window).height() - 180) {

    header.addClass('animate');
    header.find('img').css('visibility', 'initial');
    header.find('.btn').css('background', 'white');
    $('#index-overlay').find('footer').find('img').hide();

  } else {

    header.removeClass('animate');
    header.find('img').css('visibility', 'hidden');
    header.find('.btn').css('background', '#e8e8e3');
    $('#index-overlay').find('footer').find('img').show();
  }
}

$(function() {

  aos.init({
    duration: 1000
  });

  $('.hamburger').click(function() {
    $(this).toggleClass('is-active');
    $('#overlay').toggleClass('active');
    $('header,body').toggleClass('hamburger-open');
  });

  if ($('body').hasClass('home')) {

    header_scroll($);

    $(window).scroll(function() {

      header_scroll($);
    });
  }

  ww.textarea_auto_resize($);
  ww.builder_js(ww, $);
});